import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { ReactNode } from 'react';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type EmptyFallbackCellValue = ReactNode;

interface EmptyFallbackCellProps<R extends GridValidRowModel = any> {
  value: EmptyFallbackCellValue;
  row: R;
}

export const EmptyFallbackCell = ({ value }: EmptyFallbackCellProps) => {
  return <>{isNil(value) ? NULLISH_CELL_VALUE : value}</>;
};
